const appConfig = {
  defaultPath: "/auth/signin",
  basename: "", // only at build time to set, like ///mintone/react/default
};

export default appConfig;
